// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___EfjHx","containerInner":"style__containerInner___2j5Ar"};


//////////////////
// WEBPACK FOOTER
// ./src/components/feed/style.css
// module id = 1192
// module chunks = 0